import { FOR_WHO } from "../data";
import SectionHeader from "./SectionHeader";
import { useSectionTrack } from "../hooks/useSectionTrack";

// Per-card surface variants. All use glass to adapt to the atmosphere behind.
const VARIANTS = [
  { cls: "glass",        hoverCls: "card-lift",        tagColor: "rgba(255,255,255,.45)" },
  { cls: "glass accent", hoverCls: "card-accent-lift", tagColor: "#FFB850",
    extraStyle: {
      background: "linear-gradient(160deg, rgba(255,102,0,.18) 0%, rgba(255,154,64,.04) 100%)",
      borderColor: "rgba(255,122,48,.30)",
    } },
  { cls: "glass-strong", hoverCls: "card-lift",        tagColor: "rgba(255,255,255,.45)" },
];

export default function ForWho() {
  const ref = useSectionTrack("for_who");

  return (
    <section ref={ref} className="sec" style={{ background: "transparent" }}>
      <SectionHeader label="Для кого" title="Звучит знакомо?" />
      <div className="grid-3">
        {FOR_WHO.map((c, i) => {
          const v = VARIANTS[i] ?? VARIANTS[0];
          return (
            <div
              key={c.tag}
              className={`card-base card-pad-xl ${v.cls} ${v.hoverCls} section-enter section-enter-delay-${i + 1}`}
              style={v.extraStyle}
            >
              <span className="eyebrow-xs" style={{ color: v.tagColor }}>{c.tag}</span>
              <h3 className="card-title-lg">{c.title}</h3>
              <p className="card-body-md" style={{ marginTop: "auto" }}>{c.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
